import React from "react";

export default function MiniMarkdown({ source, T }) {
  if (!source) return null;
  const lines = source.split("\n");
  const out = [];
  let listBuf = null, numListBuf = null;

  const flush = () => {
    if (listBuf) {
      out.push(<ul key={out.length} style={{ listStyle: "disc", paddingLeft: 22, marginBottom: 20, color: T.textMute, lineHeight: 1.75 }}>{listBuf}</ul>);
      listBuf = null;
    }
    if (numListBuf) {
      out.push(<ol key={out.length} style={{ listStyle: "decimal", paddingLeft: 22, marginBottom: 20, color: T.textMute, lineHeight: 1.75 }}>{numListBuf}</ol>);
      numListBuf = null;
    }
  };

  const inline = (text) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) => p.startsWith("**") && p.endsWith("**")
      ? <strong key={i} style={{ fontWeight: 600, color: T.text }}>{p.slice(2, -2)}</strong>
      : <span key={i}>{p}</span>);
  };

  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed.startsWith("## ")) {
      flush();
      out.push(<h2 key={out.length} style={{
        fontSize: "1.75rem", fontWeight: 700, letterSpacing: "-0.02em",
        color: T.text, marginTop: 40, marginBottom: 16
      }}>{trimmed.slice(3)}</h2>);
    } else if (trimmed.startsWith("- ")) {
      if (!listBuf) listBuf = [];
      listBuf.push(<li key={listBuf.length} style={{ marginBottom: 4 }}>{inline(trimmed.slice(2))}</li>);
    } else if (/^\d+\.\s/.test(trimmed)) {
      if (!numListBuf) numListBuf = [];
      numListBuf.push(<li key={numListBuf.length} style={{ marginBottom: 4 }}>{inline(trimmed.replace(/^\d+\.\s/, ""))}</li>);
    } else if (trimmed === "") {
      flush();
    } else {
      flush();
      out.push(<p key={out.length} style={{ fontSize: 16, lineHeight: 1.7, color: T.textMute, marginBottom: 14 }}>{inline(trimmed)}</p>);
    }
  }
  flush();
  return <>{out}</>;
}
